// src/persist.js
export const load = (k, fallback) => {
    try {
      const raw = localStorage.getItem(k);
      return raw == null ? fallback : JSON.parse(raw);
    } catch {
      return fallback;
    }
  };
  
  export const save = (k, v) => {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch {}
  };
  
  // Debounced saver for noisy state (e.g., steps, chats, code)
  export const debouncedSaver = (k, wait = 300) => {
    let t = null;
    return (v) => {
      if (t) clearTimeout(t);
      t = setTimeout(() => save(k, v), wait);
    };
  };
  